/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.I
import systems.frictionless.impulse.browser.composable.component.Text
import systems.frictionless.impulse.markdown.model.Token
import systems.frictionless.impulse.markdown.parser.MarkdownParser

@Composable
fun Markdown(markdown: String) {
    val tokens = MarkdownParser.parse(markdown)
    tokens.forEach { token ->
        when (val tokenType = token.type) {
            is Token.Type.Plain -> {
                Text(token.text)
            }
            is Token.Type.Bold -> {
                B { Text(token.text) }
            }
            is Token.Type.Italic -> {
                I { Text(token.text) }
            }
            is Token.Type.Link -> {
                A(href = tokenType.url, attrs = {
                    target(ATarget.Blank)
                }) {
                    Text(token.text)
                }
            }
            else -> {
                throw UnsupportedOperationException("I don't know how to handle token type `$tokenType`")
            }
        }
    }
}
